import React from 'react';

const GSTR = () => {

  return (
    <div className="px-6">
      <div className="">
        <div className="">
            <h1>dsllds</h1>
        </div>
      </div>
    </div>
  );
};

export default GSTR;
